// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MaterialsList_wrapper__1RtK3","messageContainer":"MaterialsList_messageContainer__1sK01","message":"MaterialsList_message__9fHZ2"};